export default __webpack_public_path__ + "static/media/Inter-VariableFont_slnt,wght.f958c681d7293226a31914e27c15cc83.ttf";